import { useEffect, useRef } from "react";

// Animated concentric bathymetric contour lines that gently ripple.
export const BathymetricCanvas = ({ className = "" }) => {
  const canvasRef = useRef(null);
  const raf = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let w, h, cx, cy;

    const resize = () => {
      const dpr = window.devicePixelRatio || 1;
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cx = w * 0.68;
      cy = h * 0.5;
    };
    resize();
    window.addEventListener("resize", resize);

    let t = 0;
    const rings = 16;
    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      for (let i = 0; i < rings; i++) {
        const base = 34 + i * 34;
        const wobble = Math.sin(t / 60 + i * 0.5) * 6;
        const r = base + wobble;
        ctx.beginPath();
        for (let a = 0; a <= Math.PI * 2 + 0.1; a += 0.12) {
          const noise =
            Math.sin(a * 3 + t / 80 + i) * (6 + i) +
            Math.cos(a * 5 - t / 120) * (3 + i * 0.4);
          const rr = r + noise;
          const x = cx + Math.cos(a) * rr;
          const y = cy + Math.sin(a) * rr * 0.72;
          if (a === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        }
        ctx.closePath();
        const alpha = 0.05 + (1 - i / rings) * 0.22;
        const hue = 186 + i * 2;
        ctx.strokeStyle = `hsla(${hue}, 90%, 55%, ${alpha})`;
        ctx.lineWidth = i < 3 ? 1.6 : 1;
        ctx.stroke();
      }
      t += 1;
      raf.current = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(raf.current);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={canvasRef} className={className} aria-hidden="true" />;
};
